<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model.ts'

defineProps({
  closets: {
    type: String,
    default: '',
  },
  index: {
    type: Number,
    required: true,
  },
})

const { dragStartHandler } = useModel()
</script>

<template>
  <div
    class="drag-item"
    :draggable="true"
    @dragstart="(event: DragEvent) => dragStartHandler(event, closets, index)"
  >
    <slot />
  </div>
</template>
